import React, { useContext, useEffect, useState } from 'react';
import h from '../../helpers/common';
import url from '../../helpers/url';
import f from '../../helpers/formatter';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import { EVENT, KEYS } from '../../contexts/MixpanelConstants';
import { COMPONENT_TYPES } from '../../config/constants';
import { ButtonCarousel } from '@intigral/ui/components/ButtonCarousel';
import { __ } from '../../translations';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import useLanguage from '../../hooks/useLanguage';
import { setSession } from '@intigral/utils/lib/browser-storage/localStorage';

interface Languages {
    ar?: string;
    en?: string;
}

interface ContentItem {
    filterName: any;
    url: string;
    genre?: Languages;
    poster: string;
}

interface GenresCarouselProps {
    id?: string;
    name?: string;
    data?: Array<any>;
    meta?: {
        carouselType?: string;
        title?: Languages;
        listbtn_target?: string;
        subscriptionGuid?: string;
        subscriptionGuids?: string;
        carousel_link_target?: string;
    };
    carousel?: Carousel;
}
interface DataItem extends SubItem {
    data?: {
        content?: Array<SubItem>;
    };
}

interface SubItem {
    filterName: any;
    title_resource_key?: string;
    background_image_new?: string;
}

export const GenresCarousel: React.FC<GenresCarouselProps> = (props) => {
    const [content, setContent] = useState<ContentItem[]>([]);
    const [useUrlParams, setUseUrlParams] = useState<boolean>(true);
    const sliderSettings = h.getSliderSettings() || {};

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const { track } = useContext(MixpanelContext) || { track: () => {} };

    const componentId = props.id || '';
    const language = useLanguage();
    const settings = {
        infinite: false,
        // slidesToShow: 6,
        // slidesToScroll: 3,
        // rtl: language === 'ar',
        // variableWidth: false,
        // initialSlide: language === 'ar' ? 5 : 0,
        // responsive: [
        //     {
        //         breakpoint: 769,
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 3,
        //             infinite: true,
        //             dots: false,
        //             initialSlide: language === 'ar' ? 2 : 0,
        //         },
        //     },
        //     {
        //         breakpoint: 1212,
        //         settings: {
        //             slidesToShow: 5,
        //             slidesToScroll: 3,
        //             infinite: true,
        //             dots: false,
        //             initialSlide: language === 'ar' ? 2 : 0,
        //         },
        //     },
        // ],
    };

    const swiperSettings = {
        // autoplay: false,
        // freeMode: false,
        // loop: false,
        slidesPerView: 2.3,
        slidesPerGroup: 1,
        // initialSlide: 0,
        virtual: false,
        dir: language === 'ar' ? 'rtl' : 'ltr',
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
            924: {
                slidesPerView: 5,
            },
            1212: {
                slidesPerView: 6,
            },
        },
    };

    // send url params if all of the posters url don't have live in it, as it's not supposed to send any urlparams in the header
    useEffect(() => {
        const transformedContent = Array.isArray(props.data)
            ? props.data.flatMap((item: DataItem) => {
                  // Handle if the item has nested content within data field
                  if (item.data && item.data.content) {
                      return item.data.content.map((subItem: SubItem) => ({
                          //url: subItem.dataSources?.[0] || `/path/to/genre/${subItem.id}`, // Adjust the URL as needed
                          url: '',
                          genre: {
                              ar: subItem.title_resource_key, // Use actual Arabic translation if available
                              en: subItem.title_resource_key, // Use actual English translation if available
                          },
                          filterName: subItem.filterName,
                          poster: subItem.background_image_new,
                      }));
                  } else {
                      // Handle direct item format without nested data field
                      return {
                          url: f.getGenreLink(item) as string,
                          genre: {
                              ar: __(item.title_resource_key),
                              en: __(item.title_resource_key),
                          },
                          filterName: item.filterName,
                          poster: item.background_image_new,
                      };
                  }
              })
            : []; // Default to an empty array if props.data is not an array

        setContent(transformedContent);
    }, [props.data]);

    useEffect(() => {
        if (content.filter((poster) => poster.url).every((poster) => poster.url.includes('live'))) {
            setUseUrlParams(false);
        } else {
            setUseUrlParams(true);
        }
    }, [content]);

    // if ('genresCarousel' in sliderSettings) {
    //     const contentWithoutNulls = content.filter((c) => c.url);
    //     if (
    //         'slidesToScroll' in sliderSettings.genresCarousel &&
    //         contentWithoutNulls.length % 6 === 0 &&
    //         sliderSettings.genresCarousel.slidesToScroll % 6 === 0
    //     )
    //         settings.slidesToScroll = sliderSettings.genresCarousel.slidesToScroll;
    //     else settings.slidesToScroll = contentWithoutNulls.length % 6;
    //     if (
    //         'responsive' in sliderSettings.genresCarousel &&
    //         'slidesToScroll' in sliderSettings.genresCarousel.responsive &&
    //         contentWithoutNulls.length % 3 === 0 &&
    //         sliderSettings.genresCarousel.responsive.slidesToScroll % 3 === 0
    //     )
    //         settings.responsive[0].settings.slidesToScroll = sliderSettings.genresCarousel.responsive.slidesToScroll;
    //     else settings.responsive[0].settings.slidesToScroll = 3 - (contentWithoutNulls.length % 3);
    // }

    const handleItemClick = (item) => {
        const { screenName, menuName } = h.getScreenMixpanelDataById(item);
        const eventProps = {
            [KEYS.CAROUSEL.SCREEN_NAME]: h.getScreen(),
            [KEYS.CAROUSEL.CAROUSEL_NAME]: props.name,
            [KEYS.CAROUSEL.CAROUSEL_TYPE]: h.getCarouselComponentType(COMPONENT_TYPES.GENRES_CAROUSEL),
        };
        track(`${EVENT.PROVIDER.PROVIDER_ITEM_CLICK}`, {
            [KEYS.GENERAL.PROVIDER_NAME]: menuName || screenName,
            ...eventProps,
        });
    };

    const items = content
        .filter((item) => item.poster != null && item.url != null && item.filterName != 'Favorite')
        .map((item) => {
            const posterStyleSplitted = item.poster.split('/');
            const filterName = item.filterName;
            const posterStyle = posterStyleSplitted[posterStyleSplitted.length - 1].split('.')[0] || '';
            const [baseUrl, params = ''] = item.url.split('?');

            // Determine base path and URL based on carouselType
            let basePath;
            if (props.meta?.carouselType === 'livetv') {
                // For LiveTV, create URL with genre parameter
                const genreId = filterName || '';
                basePath = `${url.route('livetv')}?genre=${btoa(genreId)}`;
            } else {
                basePath = item.url; // Default behavior for other types
            }

            return {
                id: baseUrl,
                locked: false,
                url: basePath,
                title: __(item.genre[language || 'ar']),
                imageLink: item.poster,
                class: posterStyle,
                show: true,
            };
        });

    return (
        <ButtonCarousel
            textOnly={true}
            title={f.getComponentTitle(props.meta)}
            id={componentId}
            list={items}
            sliderSettings={swiperSettings}
            itemClickCallback={(item) => {
                const itemIsLiveTV = typeof item?.url === 'string' && item.url.includes('livetv');
                if (itemIsLiveTV) {
                    setSession('noAds', 'true');
                }
                handleItemClick(item.id);
            }}
            direction={language == 'ar' ? 'rtl' : 'ltr'}
            carousel={props?.carousel}
        />
    );
};
